import { ArrowRight } from "lucide-react";
import { useStore } from "zustand";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { uiStore } from "@/lib/stores/ui-store";

export function MoveNotificationOverlay() {
	const pendingMove = useStore(uiStore, (state) => state.pendingMove);

	if (!pendingMove) return null;

	const message = pendingMove.isPullTogether
		? `You are being pulled together to ${pendingMove.channelName}`
		: `A moderator is moving you to ${pendingMove.channelName}`;

	return (
		<div className="pointer-events-none absolute inset-0 z-50 flex items-center justify-center px-4">
			<Alert className="w-auto max-w-2xl border-green-500/50 bg-green-500/20 shadow-[0_0_20px_rgba(34,197,94,0.4)] backdrop-blur-sm">
				<ArrowRight className="size-5 animate-pulse text-green-500" />
				<AlertDescription className="font-semibold text-green-500 text-lg">
					{message}
				</AlertDescription>
			</Alert>
		</div>
	);
}
